<template>
  <header>
    <div class="title is_show_flex">
      <div class="between">
        <div class="left">
          <span
            class="menuImg"
            @click="() => isMore = !isMore"
          >
            <img :src="require('@/assets/img/website/menu.png')" alt="" />
          </span>
          <span class="leftLine"></span>
          <a
            v-for="(item, index) in tabList"
            :key="index"
            class="menuTxt"
            :href="`/list/category/${item.toLowerCase()}`"
            >{{ item }}</a
          >
        </div>
        <div :class="['center', isSearch ? 'search-center' : '' ]">
          <a href="/" class="flex-style"
            ><img :src="require('@/assets/img/website/logo.png')" alt=""
          /></a>
        </div>
      </div>
      <div class="right">
        <div class="rightIcon ismobile">
          <img
            :src="require('@/assets/img/website/social.png')"
            @mouseenter="showPopover"
            @mouseleave="hidePopover"
          />
          <div v-if="showSocial" class="social" @mouseenter="showPopover" @mouseleave="hidePopover">
            <a
              v-for="item in socialList"
              :key="item.id"
              @click="toSocial(item.href)"
            >
              <img :src="item.imgUrl" alt="" />
            </a>
          </div>
        </div>
        <span class="rightIcon ismobile">
          <img :src="langImg" @mouseenter="showPopover2" @mouseleave="hidePopover2" />
          <div v-if="showLang" class="lang" @mouseenter="showPopover2" @mouseleave="hidePopover2">
            <a v-for="item in langList" :key="item.id" :href="item.href">
              {{ item.label }}
            </a>
          </div>
        </span>
        <span v-if="!isSearch" class="rightLine ismobile"></span>

        <span v-if="!isSearch" class="rightIcon" @click="toSearch">
          <img :src="require('@/assets/img/website/search.png')" alt="" />
        </span>

        <div v-if="isSearch" class="searchBox">
          <a-input v-model="searchVal"></a-input>
          <span class="rightLine ismobile"></span>
          <span class="rightIcon" @click="search">
            <img :src="require('@/assets/img/website/search.png')" alt="" />
          </span>
        </div>
      </div>
    </div>
    <div class="mobileHeader is_hide_block">
      <div class="mbTitle">
        <div class="left" @click="() => isMore = !isMore">
          <span class="menuImg">
            <img :src="require('@/assets/img/website/mb-menu.png')" alt="" />
          </span>
        </div>
        
        <div class="center">
          <a href="/"
            ><img :src="require('@/assets/img/website/mb-logo.png')" alt=""
          /></a>
        </div>
        <div class="right">
          <div class="mobileLang">
            <!-- 选择语言 -->
            <div class="mobileLangDiv">
              <span class="rightIcon ismobile mobileLang-span">
                <img :src="langImg" alt="" />
                <div v-show="showLang" class="lang">
                  <a v-for="item in langList" :key="item.id" :href="item.href">
                    {{ item.label }}
                  </a>
                </div>
              </span>
            </div>

            <!-- 搜索 -->
            <div v-if="!isSearch">
              <span class="rightIcon mobileLang-span" @click="toSearch">
                <img                 
                  :src="require('@/assets/img/website/mb-search.png')"
                  alt=""
                />
              </span>
            </div>
            <div v-else>
              <aInput class="mb_input" v-model="searchVal"></aInput>
              <span class="rightIcon mobileLang-span" @click="search">
                <img
                  :src="require('@/assets/img/website/mb-search.png')"
                  alt=""
                />
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="mbMenu">
        <a
          v-for="(item, idx) in tabList"
          :key="idx"
          class="menuTxt"
          :href="`/list/category/${item.toLowerCase()}`"
          >{{ item }}
        </a>
      </div>
    </div>
    <div v-show="isMore" class="menuList mb-menuList" @mouseleave="closeMenulist">
      <p class="mbClose is_hide_block" @click="closeMenulist">
        <img :src="require('@/assets/img/website/mb-close.png')" alt="" />
      </p>
      <div class="mb-menuBox">
        <p v-if="isMobile" class="mb-menuTit">LANGUAGE SWITCHING</p>
        <div v-if="isMobile">
          <a
            v-for="item in langList"
            :key="item.id"
            :href="item.href"
            class="mb-menutext"
          >
            <span>{{ item.label }}</span>
          </a>
        </div>
        <p v-if="isMobile" class="line mb-line"></p>
        <p class="menuTit mb-menuTit">CATEGORY</p>
        <p
          v-for="(item, idx) in tabList"
          :key="idx"
          class="menutext mb-menutext"
        >
          <span
            ><a
              :href="`/list/category/${item.toLowerCase()}`"
              style="color: white"
              >{{ item }}</a
            ></span
          >
        </p>
        <p class="line mb-line"></p>
        <p class="about">
          <span>ARCHIVE</span>
        </p>
        <a class="about" href="/detail/79687">
          <span>ABOUT</span>
        </a>
      </div>
    </div>
  </header>
</template>
<script>
import aInput from "ant-design-vue/lib/input";
export default {
  components: {
    aInput,
  },
  props: {
    isMobile: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    let retData = {
      active: 0,
      isMore: false,
      searchVal: "",
      isSearch: false,
      showSocial: false,
      showLang: false,
      langImg: require("@/assets/img/website/lang.png"),
      langList: [
        {
          id: 2,
          label: "JAPANESE",
          href: "https://www.honeyee.com",
        },
        {
          id: 1,
          label: "CHINESE",
          href: "https://chinese.honeyee.com",
        },
        {
          id: 3,
          label: "ENGLISH",
          href: "https://english.honeyee.com",
        },
      ],
      tabList: [],
      socialList: [
        {
          id: 1,
          href: "https://twitter.com/honeyee_com",
          imgUrl: require("@/assets/img/website/header/twitter.png"),
        },
        {
          id: 2,
          href: "https://www.facebook.com/honeyeecom",
          imgUrl: require("@/assets/img/website/header/facebook.png"),
        },
        {
          id: 3,
          href: "https://www.instagram.com/honeyee.com_webmagazine/",
          imgUrl: require("@/assets/img/website/header/ins.png"),
        },
        {
          id: 4,
          href: "",
          imgUrl: require("@/assets/img/website/header/weixin.png"),
        },
        {
          id: 5,
          href: "",
          imgUrl: require("@/assets/img/website/header/weibo.png"),
        },
      ],
      timer: null,
      timer2: null
    };
    retData.tabList = this.$store.state.detail.categorys.slice(0, 3) || [];
    return retData;
  },
  created() {
    if (process.env.VUE_ENV !== "server") {
      let menuList = sessionStorage.getItem("menuList");
      console.log(menuList);
      if (!menuList) {
      } else {
        this.tabList = menuList.split(",");
      }
      if (this.$route.path != "/") {
        this.active = "";
      }
      let host = window.location.hostname;
      if (host.indexOf("chinese.honeyee") != -1) {
        this.langImg = require("@/assets/img/website/langCH.png");
      } else if (host.indexOf("english.honeyee") != -1) {
        this.langImg = require("@/assets/img/website/langEN.png");
      } else {
        this.langImg = require("@/assets/img/website/lang.png");
      }
    }
  },
  watch: {
    isMobile: {
      handler(newValue, oldValue) {
        this.mobile = newValue;
        console.log(this.isMobile);
      },
    },
  },
  methods: {
    toSocial(href) {
      window.open(href);
    },
    routerEvent(anchor, index) {
      this.active = index;
      this.$emit("anchorScoll", { anchor, index });
    },
    showMenlist() {
      this.isMore = true;
    },
    closeMenulist() {
      this.isMore = false;
    },
    showPopover() {
      if (this.timer) clearTimeout(this.timer)
      this.showSocial = true
      this.showLang = false
      // this.$emit("showMask", true);
    },
    hidePopover() {
      this.timer = setTimeout(() => {
        this.showSocial = false
        // this.$emit("showMask", false);
        clearTimeout(this.timer)
        this.timer = null
      }, 500)
    },
    showPopover2() {
      if (this.timer2) clearTimeout(this.timer2)
      this.showSocial = false
      this.showLang = true
      // this.$emit("showMask", true);
    },
    hidePopover2() {
      this.timer2 = setTimeout(() => {
        this.showLang = false
        // this.$emit("showMask", false);
        clearTimeout(this.timer2)
        this.timer2 = null
      }, 500)
    },
    toSearch() {
      this.isSearch = true;
    },
    search() {
      if (this.searchVal == "") {
        this.isSearch = false;
      } else {
        window.location = "/list/search/" + this.searchVal;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.mobileLang {
  display: flex;
  align-items: center;
  margin-left: 5px;
  position: relative; 
  height: 32px;
  margin-top: -4.7px;
  .mobileLangDiv {
      margin-right: 20px;
    position: relative;
    //top:-5px;
    // left: 50px;
    .lang {
      position: absolute;
      display: inline-block;
      z-index: 9999;
      right: -30px;
      top: 30px;
      padding: 20px;
      cursor: pointer;
      border-radius: 4px;
      background: rgba($color: #000000, $alpha: 0.5);
      height: 32px;
      a {
        font-family: Helvetica;
        font-size: 16px;
        line-height: 20px;
        color: #ffffff;
        border-bottom: 1px solid #ffffff;
        display: inline-block;
        margin-bottom: 26px;
        &:last-child {
          margin-bottom: 0px;
        }
      }
    }
  }
  >div{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    // .mb_input{
    //   margin-top: -4.6px;
    // }
    .mobileLang-span{
      height: 16 * $px;
      img{
        height: 100%;
      }
    }
  }
}

.title {
  z-index: 999;
  position: fixed;
  top: 0;
  width: 100%;
  background: rgba(10, 10, 10, 0.73);
  display: flex;
  height: 80px;
  align-items: center;
  justify-content: space-between;
  padding-right: 40px;
  .between {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    width: 55.6%;
    .left {
      margin-left: 40px;
      display: flex;
      height: 100%;
      align-items: center;
      flex: 1;
      .menuImg {
        width: 24px;
        height: 100%;
        display: flex;
        align-items: center;
        cursor: pointer;

        img {
          width: 24px;
        }
      }
      .leftLine {
        height: 24px;
        width: 1px;
        background: #fff;
        margin-left: 50px;
      }
      .menuTxt {
        font-family: Helvetica;
        font-size: 16px;
        line-height: 20px;
        letter-spacing: 0.05em;
        color: #ffffff;
        margin-left: 50px;
        cursor: pointer;
      }
    }
    .center {
      // margin-left: 260px;    
      height: 100%;
      display: flex;
      align-items: center;
      cursor: pointer;

      a {
        width: 218px;      
        img {
          width: 218px;
        }
      }
    }
  }
  .right {
    display: flex;
    height: 100%;
    align-items: center;
    .rightIcon {
      position: relative;
      margin-left: 20px;
      display: flex;
      align-items: center;       
      height: 16 * $px;
      width: 24px;
      img {
        width: 24px;
        cursor: pointer;
      }
      .social {
        position: absolute;
        display: flex;
        z-index: 9999;
        right: 0;
        padding: 10px 10px 5px 10px;
        top: 58px;
        cursor: pointer;
        border-radius: 4px;
        background: rgba($color: #000000, $alpha: 0.5);
        a {
          display: inline-block;
          margin-right: 12px;
          cursor: pointer;
          &:last-child {
            margin-right: 0px;
          }

          img {
            width: auto;
            height: 22px;
          }
        }
      }
      .lang {
        position: absolute;
        z-index: 9999;
        right: 0;
        padding: 20px;
        top: 58px;
        cursor: pointer;
        border-radius: 4px;
        background: rgba($color: #000000, $alpha: 0.5);
        a {
          font-family: Helvetica;
          font-size: 16px;
          line-height: 20px;
          color: #ffffff;
          border-bottom: 1px solid #ffffff;
          display: inline-block;
          margin-bottom: 26px;
          &:last-child {
            margin-bottom: 0px;
          }
        }
      }
    }
    .searchBox {
      border-bottom: 1px solid rgba(255, 255, 255, 0.21);
      width: 300px;
      margin-right: 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .rightLine {
        height: 24px;
        width: 1px;
        background: #fff;
        margin-right: 20px;
        display: inline-block;
      }
      .rightIcon {
        display: flex;
        align-items: center;
        width: 24px;
        height: 16 * $px;
        margin-right: 10px;
        cursor: pointer;
        img {
          width: 24px;
        }
      }
      .ant-input{
        margin-left: 12px;
        background-color: transparent;
        border: none;
        color: #fff;        
      }
      .ant-input:focus {
        border: none;
        box-shadow: none;
      }
      ::v-deep.ant-input {
        background-color: transparent;
        border: none;
        color: #fff;       
      }
      ::v-deep.ant-input:focus {
        border: none;
        box-shadow: none;
      }
    }
  }
}
.mobileHeader {
  width: 100%;
  background: #0a0a0a;
  z-index: 9999;
  position: fixed;
  top: 0;
  .mbTitle {
    display: flex;
    height: 40 * $px;
    align-items: center;
    justify-content: space-between;
    padding: 13 * $px 25 * $px 7 * $px 25 * $px;
    .left {
      height: 100%;
      .menuImg {
        width: 16 * $px;
        img {
          width: 16 * $px;
        }
      }
    }
    .center {
      a {
        display: flex;
        align-items: center;
        width: 134 * $px;
        img {
          width: 134 * $px;
        }
      }
    }
    .right {
      height: 100%;
      .rightIcon {
        display: flex;
        align-items: center;       
        height: 16 * $px;
        width: 16 * $px;
        img {
          width: 16 * $px;
        }
      }
      .mb_input {
        width: 80 * $px;
      }
      ::v-deep.ant-input {
        background-color: #fff;
        border: none;
        color: #232323;
        height: 20 * $px;
      }
      ::v-deep.ant-input:focus {
        border: none;
        box-shadow: none;
      }
    }
  }
  .mbMenu {
    display: flex;
    padding: 0 24 * $px;
    width: 100%;
    height: 36 * $px;
    justify-content: space-between;
    align-items: center;
    .menuTxt {
      font-family: Helvetica;
      font-size: 12px;
      line-height: 20px;
      letter-spacing: 0.05em;
      color: rgba(255, 255, 255, 0.7);
      // padding: 0 10 * $px;
      padding: 0;
      height: 100%;
      line-height: 36 * $px;
    }
    .active {
      border-bottom: 2px solid #ffd544;
      color: #ffffff;
    }
  }
}

.menuList {
  z-index: 999;
  position: fixed;
  width: 212px;
  height: 427px;
  left: 0px;
  top: 85px;
  background: rgba(10, 10, 10, 0.73);
  padding: 60px 40px;
  .menuTit {
    font-family: Helvetica;
    font-size: 16px;
    line-height: 20px;
    color: #ffffff;
  }
  .menutext {
    font-family: Helvetica;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.05em;
    margin-top: 1em;
    color: #ffffff;
    cursor: pointer;
    span {
      border-bottom: 1px solid #ffffff;
    }
  }
  .line {
    width: 132px;
    height: 1px;
    margin: 40px 0;
    background: rgba(255, 255, 255, 0.14);
  }
  .about {
    font-family: Helvetica;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.05em;
    margin-bottom: 1em;
    color: #ffffff;
    cursor: pointer;
    span {
      border-bottom: 1px solid #ffffff;
    }
  }
}

@media screen and (min-width: 1250px) and (max-width: 1920px) {
  .title {
    .between {
      .left {
        .leftLine {
          height: 24px;
          width: 1px;
          background: #fff;
          margin-left: 5%;
        }
        .menuTxt {
          font-family: Helvetica;
          font-size: 16px;
          line-height: 20px;
          letter-spacing: 0.05em;
          color: #ffffff;
          margin-left: 5%;
        }
        .center {
          margin-left: 10%;
          a {
            width: 218px;
            img {
              width: 218px;
            }
          }
        }
      }     
    }
  }
}

@media screen and (min-width: 910px) and (max-width: 1250px) {
  .title {
    .between {
      width: 65%;
      .left {
        .leftLine {
          height: 24px;
          width: 1px;
          background: #fff;
          margin-left: 5%;
        }
        .menuTxt {
          font-family: Helvetica;
          font-size: 16px;
          line-height: 20px;
          letter-spacing: 0.05em;
          color: #ffffff;
          margin-left: 5%;
        }
      }     
      .center {
        margin-left: 5%;
        a {
          width: 218px;
          img {
            width: 218px;
          }
        }
      }
      .search-center{
        margin-left: 0;
        a {
          width: 140px;
          img {
            width: 140px;
          }
        }
      }
    }
    .right{
      .searchBox {
        width: 160px;
      }
    }
  }
}

@media screen and (min-width: 750px) and (max-width: 910px) {
  .title {
    .between {
      width: 78%;
      .left {
        .leftLine {
          height: 24px;
          width: 1px;
          background: #fff;
          margin-left: 5%;
        }
        .menuTxt {
          font-family: Helvetica;
          font-size: 16px;
          line-height: 20px;
          letter-spacing: 0.05em;
          color: #ffffff;
          margin-left: 5%;
        }
      }
      
      .center {
        margin-left: 5%;
        a {
          width: 218px;
          img {
            width: 218px;
          }
        }
      }
      .search-center{
        margin-left: 0;
        a {
          width: 140px;
          img {
            width: 140px;
          }
        }
      }
    }
    .right {
      .ismobile {
        //display: none;
      }
     
      .searchBox {
        width: 160px;
        margin-right: 0;
        .rightLine{
          margin-right: 0;
        }
      }      
    }
  }
}

@media screen and (max-width: 750px) {
  .mobileHeader {
    .mbTitle{
      .center {    
        margin-left: 10%;
      }
      .mobileLang-span{
        margin-left: 10px;
      }
    }
  }
  .mb-menuList {
    display: block;
    z-index: 9999;
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    padding: 0;
    backdrop-filter: blur(4px);
    background: rgba($color: #000000, $alpha: 0.85);
    
    .mbClose {
      margin: 20 * $px 0 0 20 * $px;
      width: 24 * $px;
      img {
        width: 100%;
      }
    }
    .mb-menuBox {
      margin-top: 40 * $px;
      padding: 0 40 * $px;
    }
    .mb-menuTit {
      font-family: Helvetica;
      font-size: 14 * $px;
      line-height: 16 * $px;
      color: #ffffff;
    }
    .mb-menutext {
      font-family: Helvetica;
      font-size: 14 * $px;
      line-height: 20 * $px;
      color: #ffffff;
      display: block;
      width: 67 * $px;
      margin-bottom: 16 * $px;
      span {
        border-bottom: 1px solid #ffffff;
      }
    }
    .wd-80 {
      width: 80 * $px;
    }
    .line {
      width: 100%;
      height: 1px;
      margin: 40 * $px 0;
      background: rgba(255, 255, 255, 0.14);
    }
    .about {
      font-family: Helvetica;
      font-size: 16px;
      line-height: 20px;
      letter-spacing: 0.05em;
      color: #ffffff;
      span {
        border-bottom: 1px solid #ffffff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// header.vue